/* global $ */

import filter from 'lodash/filter';
import map from 'lodash/map';
import getOptionsFromPrefix from '../helpers/getOptionsFromPrefix';

const ProductsModal = {
  /**
   * Instantiate modal
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {void}
   */
  create(node, props) {
    this.node = node;

    this.options = getOptionsFromPrefix(props, 'productsModal');

    $(this.node).on('show.bs.modal', (e) => {
      this.date = e.relatedTarget.dataset.date;

      this.node.querySelector('.js-date').textContent = this.date;

      this.fetchProducts();
    });
  },

  fetchProducts() {
    window.axios.get(`orders-per-day-products/${this.date}`)
      .then((res) => {
        if (res.data) {
          this.outputData(res.data);
        }
      });
  },

  createRow(item, weight = 'span') {
    return `
      <tr>
        <td width="120"><${weight}>${item.product_id}</${weight}></td>
        <td><${weight}>${item.title}</${weight}></td>
        <td width="80"><${weight}>${item.quantity}</${weight}></td>
      </tr>
    `;
  },

  outputData(data) {
    const head = `
      <tr>
        <th width="160">ID</th>
        <th>Productnaam</th>
        <th width="80">Aantal</th>
      </tr>
    `;

    const rows = filter(map(data.products, (item, key) => {
      if (key === '') {
        return false;
      }

      return this.createRow(item);
    }));

    if (typeof data.bbqs !== 'undefined') {
      rows.push(this.createRow({
        product_id: 'BBQ\'s',
        title: '',
        quantity: data.bbqs,
      }, 'strong'));
    }

    if (typeof data.persons !== 'undefined') {
      rows.push(this.createRow({
        product_id: 'Personen',
        title: '',
        quantity: data.persons,
      }, 'strong'));
    }

    const table = `<table class="table w-100">${head}${rows.join('')}</table>`;

    this.node.querySelector('.js-content').innerHTML = table;
  },
};

export default ProductsModal;
